var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16666 1.6665H7.49999C3.33332 1.6665 1.66666 3.33317 1.66666 7.49984V12.4998C1.66666 16.6665 3.33332 18.3332 7.49999 18.3332H12.5C16.6667 18.3332 18.3333 16.6665 18.3333 12.4998V10.8332",
    stroke: "#939FC1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3667 2.51688L6.79999 9.08354C6.54999 9.33354 6.29999 9.82521 6.24999 10.1835L5.89166 12.6919C5.75832 13.6002 6.39999 14.2335 7.30832 14.1085L9.81666 13.7502C10.1667 13.7002 10.6583 13.4502 10.9167 13.2002L17.4833 6.63354C18.6167 5.50021 19.15 4.18354 17.4833 2.51688C15.8167 0.850211 14.5 1.38354 13.3667 2.51688Z",
    stroke: "#939FC1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.425 3.4585C12.9833 5.45016 14.5417 7.0085 16.5417 7.57516",
    stroke: "#939FC1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fc4b06c8b9c6ffc25b902267607508c2.svg";
export { ForwardRef as ReactComponent };